import { EventEmitter } from '@angular/core';
var AcStar = /** @class */ (function () {
    function AcStar() {
        this.rate = new EventEmitter();
    }
    AcStar.prototype.handleRate = function () {
        this.rate.emit(this.position);
    };
    return AcStar;
}());
export { AcStar };
//# sourceMappingURL=star.js.map